import React from 'react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import routePaths from '@/consts/route/routePaths';
import {twx} from '@/utils/tailwindUtils';

import AutoDeliveryEditOrderButton from './AutoDeliveryEditOrderButton';

const AutoDeliveryOrderHeader = ({titleClassName, isEditAllowed, renderAs, className}) => {
    const HeadingComponent = renderAs || 'h1';

    return (
        <div className={twx('flex items-center justify-between gap-2', className)}>
            <HeadingComponent
                className={twx(
                    'mb-0 overflow-hidden text-ellipsis whitespace-nowrap text-24 font-bold leading-13 md:text-36 md:leading-12',
                    titleClassName
                )}
            >
                <AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='yourOrderTitle' />
            </HeadingComponent>
            {isEditAllowed && <AutoDeliveryEditOrderButton />}
        </div>
    );
};

export default AutoDeliveryOrderHeader;
